export default __webpack_public_path__ + "static/media/tigerbox_touch_grey.2edb8512.png";